<template>
  <div class="dingqian-home">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="container">
        <!-- Logo 文字：DQ + 鼎乾招投标 -->
        <div class="logo-box">
          <div class="logo-dq">DQ</div>
          <div class="logo-text">鼎乾招投标</div>
        </div>
        <!-- 导航菜单 -->
        <ul class="nav-list">
          <li><a href="#">首页</a></li>
          <li><a href="#" class="active">招标公告</a></li>
          <li><a href="#" @click="goDetail">中标公示</a></li>
          <li><a href="#">政策法规</a></li>
          <li><a href="#">办事指南</a></li>
          <li><a href="#">关于我们</a></li>
        </ul>
      </div>
    </header>
    <!-- 搜索栏 -->
    <div class="search-bar">
      <div class="container">
        <input v-model="keywords" type="text" placeholder="请输入项目名称、公告类型搜索..." class="search-input" />
        <button class="search-btn">搜索</button>
      </div>
    </div>
    <!-- 主体内容 -->
    <div class="container main">
      <!-- 左侧公告 -->
      <div class="left">
        <!-- 最新公告（完整WORD原文 + 字体大小颜色美化） -->
        <div class="card">
          <div class="card-header">
            <h3>最新公告</h3>
            <a href="#">更多 ></a>
          </div>
          <div class="notice-detail">
            <div class="notice-date">2026-05-22</div>
            <h2 class="notice-title">通富智能产业园六期项目主体工程招标公告</h2>

            <div class="section">
              <h3 class="section-title">1. 招标条件</h3>
              <p class="content-normal">本招标项目通富智能产业园六期项目主体工程已由厦门市翔安区发展和改革局以厦门市翔安区发展和改革局关于通富智能产业园六期项目主体工程项目初步设计的批复，厦门市企业投资项目备案证明（内资)（翔发改备 2024510 ）批准建设，建设单位为厦门通富微电子有限公司， 建设资金来源自筹，招标人为厦门通富微电子有限公司，委托的招标代理单位为北京建友工程造价咨询有限公司。本项目已具备招标条件，现对该项目的施工进行公开招标。</p>
            </div>

            <div class="section">
              <h3 class="section-title">2. 项目概况和招标范围</h3>
              <p class="content-normal"><span class="label">2.1 工程建设地点：</span>项目位于翔安区 13-08 内厝片区民石中路与沙溪北路交叉口西北侧；</p>
              <p class="content-normal"><span class="label">2.2 工程建设规模：</span>项目总用地面积 55066.67 平方米，总建筑面积 119659.903 平方米，其中地上建筑面积 119220.203 平方米，地下建筑面积 439.70 平方米。地上层数：一到七层，地下层数：一层。最大建筑高度 37.35 米。主要建设内容包括通用厂房、门卫、变配电室、地下水泵房及水池、非机动车棚。（具体以施工图纸及审核后工程量清单为准）；</p>
              <p class="content-normal"><span class="label">2.3 招标范围和内容：</span>（1）工程类别：房屋建筑工程；（2）招标类型：施工总承包；（3）招标范围和内容： 本次招标范围为通富智能产业园六期项目主体工程施工图纸范围内的土石方工程、地基处理工程、桩基工程、地下室工程、地上主体工程、室外工程、装修工程、幕墙工程、人防工程、标识标牌工程、给排水工程、电气工程、供配电工程、消防工程、暖通工程(含空调)、智能化工程、电梯工程、通信配套工程(公众电信网)、景观工程、海绵工程、柴油发电机组、抗震支架、电梯采购及安装、燃气工程、光伏工程及相关配套工程；具体详见施工图纸及工程量清单。</p>
              <p class="content-highlight"><span class="label">2.4 招标控制价：</span><span class="price">346647867元</span></p>
              <p class="content-normal"><span class="label">2.5 工期要求：</span>总工期为<span class="date-red">720个日历天</span>，定额工期/个日历天（适用于国家或我省对工期有规定的项目）；其中各关键节点的工期要求为（如果有）/；</p>
              <p class="content-normal"><span class="label">2.6 标段划分（如果有）：</span>/；</p>
              <p class="content-normal"><span class="label">2.7 质量要求：</span>符合国家现行《工程施工质量验收规范》合格标准。</p>
            </div>

            <div class="section">
              <h3 class="section-title">3. 投标人资格要求及审查办法</h3>
              <p class="content-normal">3.1 本招标项目要求投标人须具备有效的不低于<span class="text-blue">二级建筑工程施工总承包资质</span>和《施工企业安全生产许可证》。（无需资质的项目，从其规定）</p>
              <p class="content-normal">3.2 投标人拟担任本招标项目的项目负责人（即项目经理，下同）须具备有效的不低于<span class="text-blue">一级建筑工程专业注册建造师</span>执业资格，并具备有效的安全生产考核合格证书（B证）。（无需资质的项目，从其规定）</p>
              <p class="content-normal">3.3 本招标项目不接受联合体投标。招标人接受联合体投标的，投标人自愿组成联合体的，应由/为牵头人，且各方应具备其所承担招标项目承包内容的相应资质条件；承担相同承包内容的专业单位组成联合体的，按照资质等级较低的单位确定资质等级。</p>
              <p class="content-normal">3.4 本招标项目应用福建省建筑施工企业信用综合评价分值。应用福建省建筑施工企业信用综合评价分值的项目，投标人的企业季度信用得分为房屋建筑类。以联合体参与投标的，投标人的企业季度信用得分按具有/施工总承包资质的联合体成员中的/确定。投标人的企业季度信用得分可通过福建省建筑施工企业信用综合评价系统（从福建住房和城乡建设网的“福建省住房和城乡建设综合监管服务平台”登录）查询。</p>
              <p class="content-normal">3.5 投标人“类似工程业绩”要求：/个；“类似工程业绩”是指：自本招标项目在法定媒介发布招标公告之日的前五年内（含本招标项目在法定媒介发布招标公告之日）完成的并经竣工验收合格的/。</p>
              <p class="content-normal">3.6 各投标人均可就本招标项目上述标段中的1个标段投标，但最多允许中标1个标段。（适用于分标段的项目）</p>
              <p class="content-normal">3.7 其他资格要求：具体详见招标文件资格要求。</p>
              <p class="content-normal">3.8 本招标项目采用资格后审方式对投标人的资格进行审查。</p>
            </div>

            <div class="section">
              <h3 class="section-title">4. 招标文件的获取</h3>
              <p class="content-normal">凡有意参加投标者，请于<span class="text-blue">2026-05-15 00:00:00至 2026-06-09 08:30:00</span>通过福建鼎乾招标网（<a href="https://dqztb.fj.cn" target="_blank" class="link-blue">https://dqztb.fj.cn</a>）采取无记名方式免费下载电子招标文件等相关资料。本招标项目电子招标文件使用新点投标文件制作软件(福建版)打开。投标人获取招标文件后，应检查招标文件的合法有效性，合法有效的招标文件应具有招标人和招标代理机构的电子印章；招标人没有电子印章的，须附招标人对招标代理机构的授权书。</p>
            </div>

            <div class="section">
              <h3 class="section-title">5. 评标办法和定标方式</h3>
              <p class="content-normal">5.1 本招标项目采用的评标办法：经评审的最低投标价中标法（A类）。</p>
              <p class="content-normal">5.2 本招标项目采用的定标方式：依据评标委员会推荐的中标候选人确定中标人。</p>
            </div>

            <div class="section">
              <h3 class="section-title">6. 投标保证金的提交</h3>
              <p class="content-normal">6.1 投标保证金提交的时间：电子投标文件投标截止时间前。</p>
              <p class="content-normal">6.2 投标保证金提交的金额：<span class="text-blue">20万元人民币</span>。</p>
              <p class="content-normal">6.3 投标保证金提交的方式：详见投标须知前附表。</p>
            </div>

            <div class="section">
              <h3 class="section-title">7. 投标文件的递交</h3>
              <p class="content-normal">7.1 投标文件递交的截止时间（投标截止时间，下同）：<span class="text-red">2026-06-09 08:30</span>，投标人应在截止时间前通过福建鼎乾招标网（<a href="https://dqztb.fj.cn" target="_blank" class="link-blue">https://dqztb.fj.cn</a>）递交电子投标文件；</p>
              <p class="content-normal">7.2 逾期送达的投标文件，公共资源电子交易平台将予以拒收。</p>
            </div>

            <div class="section">
              <h3 class="section-title">8. 发布公告的媒介</h3>
              <p class="content-normal">本次招标公告在福建鼎乾招标网（<a href="https://dqztb.fj.cn" target="_blank" class="link-blue">https://dqztb.fj.cn</a>）上发布。</p>
            </div>

            <div class="section">
              <h3 class="section-title">9. 联系方式</h3>
              <p class="content-contact"><strong>招标人：</strong>厦门通富微电子有限公司</p>
              <p class="content-contact"><strong>地址：</strong>厦门市海沧区南海二路89号，邮编：361000</p>
              <p class="content-contact"><strong>电子邮箱：</strong>/</p>
              <p class="content-contact"><strong>电话：</strong>0597-4822668，<strong>传真：</strong>/</p>
              <p class="content-contact"><strong>联系人：</strong>郑伟宏</p>
              <br/>
              <p class="content-contact"><strong>招标代理机构：</strong>北京建友工程造价咨询有限公司</p>
              <p class="content-contact"><strong>地址：</strong>厦门市湖里区安岭路1001号金海湾财富中心1号楼B栋701-6室，邮编：361000</p>
              <p class="content-contact"><strong>电子邮箱：</strong>/</p>
              <p class="content-contact"><strong>电话：</strong>15181351535，<strong>传真：</strong>/</p>
              <p class="content-contact"><strong>联系人：</strong> 周彩玲</p>
              <br/>
              <p class="content-contact"><strong>公共资源电子交易平台名称：</strong>福建鼎乾招标网</p>
              <p class="content-contact"><strong>网址：</strong><a href="https://dqztb.fj.cn" target="_blank" class="link-blue">https://dqztb.fj.cn</a>　<strong>联系电话：</strong> 4009996901</p>
              <br/>
              <p class="content-contact"><strong>招投标监督机构名称：</strong>厦门市翔安区住建和交通局</p>
              <p class="content-contact"><strong>地址：</strong>厦门市翔安区新店街道新店路 2009 号人力资源大厦 8 楼</p>
              <p class="content-contact"><strong>联系电话：</strong>0592-7889229</p>
              <br/>
              <p class="content-contact"><strong>公共资源交易中心名称：</strong>福建鼎乾交易中心</p>
              <p class="content-contact"><strong>地址：</strong>厦门市云顶北路 842 号（市政务服务中心 4 层）</p>
              <p class="content-contact"><strong>联系电话：</strong>0592-2677186</p>
            </div>

            <div class="notice-sign">
              招标人：厦门通富微电子有限公司<br>
              2026年05月22日
            </div>
          </div>
        </div>
        <!-- 中标公示 -->
        <div class="card">
          <div class="card-header">
            <h3>中标公示</h3>
            <a href="#">更多 ></a>
          </div>
          <div class="notice-list">
            <li><span>2026-05-22</span><a @click="goDetail">通富智能产业园六期项目中标候选人公示</a></li>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right">
        <!-- 招标文件下载卡片 - 美化版 -->
        <div class="card download-card">
          <div class="card-header">
            <h3>
              <i class="icon-download"></i> 招标文件下载
            </h3>
          </div>
          <div class="download-content">
            <div class="file-info">
              <div class="file-icon">📄</div>
              <div class="file-name">通富智能产业园六期项目主体工程 招标公告</div>
            </div>
            <!-- 下载按钮 -->
            <a class="download-btn" @click="downloadLocalFile">
              <span class="btn-text">立即下载</span>
              <span class="btn-icon">↓</span>
            </a>
          </div>
        </div>
        <div class="card">
          <div class="card-header"><h3>项目分类</h3></div>
          <div class="category-list">
            <div class="cat-item">工程建设</div>
            <div class="cat-item">政府采购</div>
            <div class="cat-item">设备采购</div>
            <div class="cat-item">服务类</div>
            <div class="cat-item">园林景观</div>
            <div class="cat-item">市政工程</div>
          </div>
        </div>
        <div class="card">
          <div class="card-header"><h3>快捷入口</h3></div>
          <div class="quick-list">
            <div class="quick-item">我要招标</div>
            <div class="quick-item">我要投标</div>
            <div class="quick-item">公告查询</div>
            <div class="quick-item">投诉监督</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <footer class="footer">
      <div class="container">
        <p>鼎乾招投标服务平台 © 2026 版权所有</p>
        <p>规范 透明 诚信 共赢</p>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "DingqianHome",
  data() {
    return {
      keywords: '',
    };
  },
  methods: {
    goDetail() {
      this.$router.push("/zbResultNotice");
    },
    downloadLocalFile() {
      const url = "/files/tfzn.doc"; // 路径对应 public/files/xxx
      const link = document.createElement("a");
      link.href = url;
      link.download = "通富智能产业园六期项目主体工程招标正文.doc";
      link.click();
    },
  }
};
</script>
<style scoped>
/* 全局 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  background: #f5f7fa;
  font-family: "Microsoft YaHei", sans-serif;
}
a {
  text-decoration: none;
  color: inherit;
}
li {
  list-style: none;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
/* 头部 */
.header {
  background: #0f469b;
  color: #fff;
  padding: 18px 0;
}
.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-box {
  display: flex;
  align-items: center;
  gap: 12px;
}
.logo-dq {
  font-size: 28px;
  font-weight: bold;
  background: #ffc107;
  color: #0f469b;
  width: 50px;
  height: 50px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-text {
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 1px;
}
.nav-list {
  display: flex;
  font-size: 16px;
}
.nav-list li {
  margin-left: 32px;
}
.nav-list a.active,
.nav-list a:hover {
  color: #ffc107;
  border-bottom: 2px solid #ffc107;
}
/* 搜索框 */
.search-bar {
  background: #fff;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
.search-bar .container {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.search-input {
  width: 600px;
  height: 44px;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0 15px;
  font-size: 14px;
  outline: none;
}
.search-btn {
  height: 44px;
  padding: 0 28px;
  background: #0f469b;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
/* 主体布局 */
.main {
  display: flex;
  gap: 20px;
  margin: 30px auto;
}
.left { flex: 3; }
.right { flex: 1; }
/* 卡片 */
.card {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}
.card-header {
  padding: 15px 20px;
  background: #f8f9fb;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-header h3 {
  color: #0f469b;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}
/* 公告字体大小 + 颜色美化 */
.notice-detail { padding: 35px; }
.notice-date { font-size: 15px; color: #666; margin-bottom: 10px; }
.notice-title {
  font-size: 26px;
  color: #0f469b;
  margin-bottom: 30px;
  font-weight: bold;
  cursor: pointer;
}
.section { margin-bottom: 30px; }
.section-title {
  font-size: 20px;
  color: #c0392b;
  margin-bottom: 15px;
  font-weight: bold;
  border-left: 4px solid #c0392b;
  padding-left: 10px;
}
/* 正文字体大小分级 */
.content-normal {
  font-size: 16px;
  color: #333;
  line-height: 2;
  margin-bottom: 8px;
}
.content-highlight {
  font-size: 17px;
  color: #222;
  line-height: 2;
  font-weight: 500;
}
.content-contact {
  font-size: 15px;
  color: #2980b9;
  line-height: 2;
}
/* 标签样式 */
.label {
  font-weight: bold;
  color: #0f469b;
}
/* 高亮颜色 */
.price { color: #e74c3c; font-weight: bold; font-size: 17px; }
.text-red { color: #e74c3c; font-weight: bold; }
.text-blue { color: #2980b9; font-weight: bold; }
.date-red { color: #c0392b; font-weight: bold; }
/* 蓝色超链接样式 */
.link-blue {
  color: #0f469b !important;
  text-decoration: underline !important;
  font-weight: 500;
}
.link-blue:hover {
  color: #1a6cef !important;
}
/* 落款 */
.notice-sign {
  margin-top: 40px;
  text-align: right;
  font-size: 16px;
  color: #333;
  line-height: 2;
  font-weight: 500;
}
/* 列表 */
.notice-list { padding: 15px 20px; }
.notice-list li {
  padding: 10px 0;
  border-bottom: 1px dashed #eee;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
/* 分类 */
.category-list {
  padding: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.cat-item {
  background: #f2f7ff;
  color: #0f469b;
  text-align: center;
  padding: 12px 0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.cat-item:hover { background: #0f469b; color: #fff; }
/* 快捷入口 */
.quick-list { padding: 15px; }
.quick-item {
  background: #0f469b;
  color: #fff;
  text-align: center;
  padding: 14px 0;
  border-radius: 6px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.quick-item:hover {
  background: #1a6cef;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(15, 70, 155, 0.2);
}
/* 底部 */
.footer {
  background: #222;
  color: #ccc;
  text-align: center;
  padding: 30px 0;
}
/* 下载卡片 美化样式 */
.download-card {
  border: 1px solid #e8f4ff;
}
.download-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #eee;
}
.file-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8f4ff;
  border-radius: 8px;
}
.file-name {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  flex: 1;
}
.download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 0;
  background: linear-gradient(135deg, #0f469b 0%, #1a6cef 100%);
  color: #fff !important;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(15, 70, 155, 0.1);
}
.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(15, 70, 155, 0.2);
  background: linear-gradient(135deg, #1a6cef 0%, #2580f7 100%);
}
.download-btn .btn-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
}
.download-btn:hover .btn-icon {
  transform: translateY(2px);
}
.download-tips {
  font-size: 12px;
  color: #999;
  text-align: center;
  padding-top: 5px;
}
</style>